// extracted by mini-css-extract-plugin
module.exports = {"submitModal":"Footer_submitModal__xdE6p"};